"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var Pager = function Pager(props) {
  var prefixCls = "".concat(props.rootPrefixCls, "-item");
  var cls = "".concat(prefixCls, " ").concat(prefixCls, "-").concat(props.page);
  if (props.active) {
    cls = "".concat(cls, " ").concat(prefixCls, "-active");
  }
  if (props.className) {
    cls = "".concat(cls, " ").concat(props.className);
  }
  var handleClick = function handleClick() {
    props.onClick(props.page);
  };
  var handleKeyPress = function handleKeyPress(e) {
    props.onKeyPress(e, props.onClick, props.page);
  };
  return /*#__PURE__*/_react["default"].createElement("li", {
    title: props.showTitle ? props.page : null,
    className: cls,
    onClick: handleClick,
    onKeyPress: handleKeyPress,
    tabIndex: "0"
  }, props.itemRender(props.page, 'page', /*#__PURE__*/_react["default"].createElement("a", null, props.page), props.size));
};
Pager.displayName = 'RcPager';
var _default = Pager;
exports["default"] = _default;